<p-toast position="top-right"></p-toast>

<div class="text-left">
  <button pButton pRipple label="Create New Roster Type" class="p-button-primary p-ml-3" icon="pi pi-calendar" (click)="addOrUpdateRosterType(null)"></button>
  <button pButton pRipple label="Collapse All" class="p-button-primary p-ml-3" icon="fas fa-angle-double-up" [disabled]="collapseAll" (click)="collapseAll = true;"></button>
  <button pButton pRipple label="Expand All" class="p-button-primary p-ml-3" icon="fas fa-angle-double-down" [disabled]="!collapseAll" (click)="collapseAll = false;"></button>
</div>

<div class="p-m-3 roster-type" *ngFor="let rosterType of rosterTypes; let i=index">
  <p-fieldset legend="{{rosterType.title}}: ({{rosterType.usage}} employees with this type)" 
    [collapsed]="collapseAll"
    [toggleable]="true">
    <p-messages 
      key="roster_type_rule"
      [value]="[{severity:'custom', summary:'Rule:', detail: rosterType.rosterTypeRule}]"
      [closable]="false"></p-messages>

    <ng-container *ngIf="rosterType.rosterTypeDescription">
      <h4>Description</h4>
      <div [innerHTML]="getDescription(rosterType.rosterTypeDescription)|safeHtml"></div>
      
    </ng-container>

    <h4>Rule preview: </h4>
    <pps-roster-type-preview [rule]="rosterType.rosterTypeRule" [rosterCodes]="rosterCodes" [rosterCodeSettings]="rosterCodeSettings"></pps-roster-type-preview>

    <div class="text-left p-mt-2">
      <button pButton pRipple label="Edit" class="p-button p-mr-2" icon="pi pi-pencil" (click)="addOrUpdateRosterType(rosterType)"></button>
      <button pButton pRipple label="Delete" class="p-button-danger" icon="pi pi-times" 
        [disabled]="rosterType.usage > 0"
        [title]="rosterType.usage > 0 ? 'To delete this roster type, you must make sure no employee was assigned to this roster type. Currently there are ' + rosterType.usage + ' employees with this type.' : 'Delete roster type'"
        (click)="deleteRosterType(rosterType)"></button>
    </div>
  </p-fieldset>
</div>

<p-confirmDialog #cd [style]="{width: '600px'}" key="rt-dialog">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>
